import React, { useState, useEffect, useContext } from 'react'
import './Timeline.css'
import { useTranslation } from 'react-i18next'
import { RiArrowLeftRightLine } from 'react-icons/ri'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { Link } from 'components/common'
import { TubularContext } from 'stores/TubularStore'

const ReturnCard = ({ data }) => {
    const { t } = useTranslation()
    const history = useHistory()
    const [selectDetail, setSelectDetail] = useState('')
    const [showReservationLink, setShowReservationLink] = useState(true)
    const { setValueData } = useContext(TubularContext)

    useEffect(() => {
        data.reservation && data.reservation.length > 4 ? setShowReservationLink(true) : setShowReservationLink(false)
        if (selectDetail === 'invoice') {
            setValueData(data.detail['Invoice Number'])
            history.push("/invoice/" + data.detail['Invoice Number'])
        } else if (selectDetail === 'sot') {
            setValueData(data.detail['Service Order'])
            history.push("/sot/" + data.detail['Service Order'])
        } else if (selectDetail === 'reservation') {
            setValueData(data.reservation)
            history.push("/reservation/" + data.reservation)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectDetail, history])

    const toGo = (value) => {
        setSelectDetail(value)
    }
    const content =
        <div className="timeline-item-content">
            <span className="title">
                <RiArrowLeftRightLine className="icon" />
                {t('tlh.ippn.return.title')}
            </span>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.return.serviceOrder')}: </span>
                    <span className="value">
                        <Link onClick={() => toGo('sot')}>
                            {data.detail['Service Order']}
                        </Link>
                    </span>
                </div>
                <div className="item">
                    <span className="label">{t('tlh.ippn.return.invoice')}: </span>
                    <span className="value">
                        <Link onClick={() => toGo('invoice')}>
                            {data.detail['Invoice Number']}
                        </Link></span>
                </div>
            </section>

            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.return.reservation')}: </span>
                    <span className="value">
                        {
                            showReservationLink ?
                                <Link onClick={() => toGo('reservation')}>
                                    {data.reservation}
                                </Link>
                                :
                                <span className="value">{data.reservation}</span>
                        }
                    </span>
                </div>
            </section>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.return.placeOrigin')}: </span>
                    <span className="value">{data.detail['Place of Origin']}</span>
                </div>
            </section>
            <section className="container row">
                <div className="item">
                    <span className="label">{t('tlh.ippn.return.destinationCustomer')}: </span>
                    <span className="value">{data.detail['Destination Customer']}</span>
                </div>
            </section>
            <span className="circle" > {moment(data.date).format('DD/MM/YYYY')}</span>
        </div>
    return content
}

export default ReturnCard